import React, { Component } from 'react';
import { connect } from 'react-redux';

import CalendarDrag from './CalendarDrag';
import DropTarget from './DropTarget';

import Console from '../../../lib/debug';

class DayContainer extends Component {
    moveCard = () => {
        //do nothing;
    };

    render() {
        Console.render('DayContainer');
        let sessions = this.props.sessions;
        let dayKey = this.props.dayKey;
        let weekIndex = this.props.weekIndex;
        let dayIndex = this.props.dayIndex;
        let items = [];
        let len = sessions.length;

        for (let i = 0; i < len; i++) {
            items.push(
                <CalendarDrag
                    key={'s' + i}
                    sessionKey={sessions[i]}
                    weekIndex={weekIndex}
                    dayIndex={dayIndex}
                    dayKey={dayKey}
                    sessionOrder={i}
                    index={i}
                    moveCard={this.moveCard}
                />
            );
        }

        let dropTarget = <DropTarget dayKey={dayKey} />;

        return (
            <div className="cal-day-body">
                {dropTarget}
                <ol className="calendar-items-list">{items}</ol>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let dayKey = ownProps.dayKey;
    let sessions = state.calendar.dayTree[dayKey]
        ? state.calendar.dayTree[dayKey].items
        : [];
    return {
        ...ownProps,
        sessions
    };
};

export default connect(mapStateToProps)(DayContainer);



// WEBPACK FOOTER //
// ./src/view/calendar/components/DayContainer.jsx